import React, { useState } from "react";
import LinkedHeader from "../../../apps/Website/pages/Trips/components/LinkedHeader";
import ArrowDown from "../../../assets/media/icons/ArrowDown";

interface AccordionProps {
  title: string;
  id?: string;
  children: React.ReactNode;
  isDefaultExpanded?: boolean;
  className?: string;
  titleClassName?: string;
  contentClassName?: string;
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  children,
  id,
  isDefaultExpanded = false,
  className = "",
  titleClassName = "",
  contentClassName = "",
}) => {
  const [isExpanded, setIsExpanded] = useState(isDefaultExpanded);

  const toggleAccordion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={` ${className}`}>
      <div
        onClick={toggleAccordion}
        className={`flex justify-between items-center py-6 sm:py-8 cursor-pointer ${titleClassName}`}
      >
        <LinkedHeader id={id}>{title}</LinkedHeader>

        <ArrowDown
          className={`w-4 h-4 ml-1 zostel-nav-arrow-transition ${
            isExpanded ? "zostel-nav-arrow-rotated" : ""
          }`}
        />
      </div>

      {isExpanded && (
        <div className={`pb-4 ${contentClassName}`}>{children}</div>
      )}
    </div>
  );
};

export default Accordion;
